import {PureComponent} from 'react'
import {Field, reduxForm} from 'redux-form'

import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import Quill from '../../Form/Field/Quill.jsx'

import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'

export const name = 'CommentsForm'

class CommentsForm extends PureComponent {
  render() {
    return <div id={name}>
      <form autoComplete="off" onSubmit={this.props.handleSubmit}>
        <div className="row">
          <div className="mb-auto col-md-12">
            <Field
              label="Commentaire"
              name="comment"
              component={Quill}
            />
          </div>
        </div>
        <input className="d-none" type="submit"/>
        <FormGlobalErrors className="mt-0" errors={this.props.error}/>
      </form>
      <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
    </div>
  }
}

export default reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name)
})(CommentsForm)